import LocationsScreen from "app/screens/locations/LocationsScreen";

export default function LocationsPage() {
  return <LocationsScreen />;
}
